import { render, staticRenderFns } from "./InputCustomerName.vue?vue&type=template&id=ff5bdc0c&scoped=true"
import script from "./InputCustomerName.vue?vue&type=script&lang=js"
export * from "./InputCustomerName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5bdc0c",
  null
  
)

export default component.exports